export default __webpack_public_path__ + "static/media/geo.9d722c57.svg";